import { Plugins } from "@capacitor/core";
const { PushNotifications } = Plugins;

import store from './store'

export function configurar () {

    // 1. configuramos el evento de "registrado correctamente en el sistema de notificaciones"
    PushNotifications.addListener ("registration",
        (token) => {
          store.commit ('TOKEN_NOTIFICACIONES', token.value);
          //alert("Registrado en el sistema de notificaciones, token: " + token.value);
          //console.log ('Token de notificaciones: ' + token.value);
        }
      );

      // 2. configuramos el evento de "error al registrarse en el sistema de notificaciones"
      PushNotifications.addListener ("registrationError",
        (error) => {
          alert("Error al registrarse en el sistema de notificaciones: " + JSON.stringify(error));
        }
      );

      // 3. lanzamos el procedimiento de registro en el sistema de notificaciones
      PushNotifications.register();
}

export function configurarEventoNotificacionRecibida (eventoNotificacionRecibida) {

    PushNotifications.addListener ("pushNotificationReceived",
      eventoNotificacionRecibida
      /*(notification) => {
        alert("Notificacion recibida: " + JSON.stringify(notification));
      }*/
    );
}

export function configurarEventoInteraccionConNotificacion (eventoInteraccionConNotificacion) {

    PushNotifications.addListener ("pushNotificationActionPerformed",
      eventoInteraccionConNotificacion
      /*(notification) => {
        alert("Interacción con notificacion: " + JSON.stringify(notification));
      }*/
    );
}